import { Card, CardContent, CardHeader } from '@mui/material';
import { ListBase, usePermissions, useTranslate } from 'react-admin';
import TransactionStatisticList from '@/components/analytics/statisticList.jsx';

const WelcomeAdmin = () => {
    const translate = useTranslate();
    return (
        <Card
            sx={{
                boxShadow: 'none',
                borderRadius: 0,
            }}
        >
            <CardHeader title={translate('dashboard.adminWelcome')} component='h3' />
            <CardContent>
                <ListBase resource='transaction'>
                    <TransactionStatisticList />
                </ListBase>
            </CardContent>
        </Card>
    );
};

const WelcomeClient = () => {
    const translate = useTranslate();
    return (
        <Card>
            <CardHeader title={translate('dashboard.clientWelcome')} />
            <CardContent>
                <ListBase resource='transaction'>
                    <TransactionStatisticList />
                </ListBase>
            </CardContent>
        </Card>
    );
};

const WelcomeService = () => {
    const translate = useTranslate();
    return (
        <Card>
            <CardHeader title={translate('dashboard.serviceWelcome')} />
        </Card>
    );
};

const WelcomeBok = () => {
    const translate = useTranslate();
    return (
        <Card>
            <CardHeader title={translate('dashboard.bokWelcome')} />
        </Card>
    );
};

export const Dashboard = () => {
    const { isLoading, permissions } = usePermissions();
    if (isLoading || !permissions) return null;

    if (permissions.isAdmin) {
        return <WelcomeAdmin />;
    } else if (permissions.isClient) {
        return <WelcomeClient />;
    } else if (permissions.isService) {
        return <WelcomeService />;
    } else if (permissions.isBok) {
        return <WelcomeBok />;
    } else {
        return null;
    }
};
